export default "__VITE_ASSET__C92as4Dr__"